import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import NavigationItem from './NavigationItem';
import { generateUniqueKey } from 'helpers';
import { bindActionCreators } from 'redux';
import { redirectToRoute } from '../../actions';

const SideMenu = ({ ...props }) => {
  const logout = () => {
    props.logout();
    props.redirectTo("/azureb2clogout");
  };

  return (
    <div className='side-menu'>
      <div className='user-info'>
        <div className='name'>{props.memberFullName}</div>
        {/* <span className="role">Real Estate Agent, Xome</span> */}
      </div>
      {
        props.items.map(listItem => <NavigationItem key={generateUniqueKey()}
          name={listItem.name}
          icon={listItem.icon}
          href={listItem.href}
          isActive={props.activeItem === listItem.name}
          changeActiveItem={props.changeActiveItem}
          displayCount={listItem.displayCount}
          totalItemsCount={listItem.totalItemsCount}
        />)
      }
      <a onClick={logout}>
        <i className='icon-logout' />
        <span>Logout</span>
      </a>
    </div>
  );
};

SideMenu.propTypes = {
  items: PropTypes.array.isRequired,
  activeItem: PropTypes.string.isRequired,
  changeActiveItem: PropTypes.func.isRequired,
  memberFullName: PropTypes.string,
  logout: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  redirectTo: bindActionCreators(redirectToRoute, dispatch)
});

export default connect((state) => ({}), mapDispatchToProps)(withRouter(SideMenu));
